// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a7b5a6e3","977":"b00c6922"}[chunkId] + ".chunk.js";
};